import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { SystemApiService } from "@cv-invision/core";
import { ClientIdentifierModel } from "../model/client-identifier.model";

@Injectable()
export class ClientIdentifierListService {
	constructor(
		private httpClient: HttpClient,
		private systemApiService: SystemApiService
	) {}

	/**
	 * Get a list of available integrations.
	 */
	public getAllIntegrations(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}/utils/integrations/list-all`
		);
	}

	/**
	 * Get a list of client identifiers by integration name.
	 */
	public getList(integrationName: string): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}/utils/integrations/${integrationName}/client-identifiers`
		);
	}

	/**
	 * Create Client Identifier
	 */
	public create(integrationName: string, model: any): Observable<any> {
		return this.httpClient.post(
			`${this.systemApiService.api.orders}/utils/integrations/${integrationName}/client-identifiers`,
			model
		);
	}

	/**
	 * Update Client Identifier
	 */
	public update(integrationName: string, model: any): Observable<any> {
		return this.httpClient.put(
			`${this.systemApiService.api.orders}/utils/integrations/${integrationName}/client-identifiers/${model.id}`,
			model
		);
	}

	/**
	 * Delete Client Identifier
	 */
	public delete(integrationName: string, model: any): Observable<any> {
		return this.httpClient.delete(
			`${this.systemApiService.api.orders}/utils/integrations/${integrationName}/client-identifiers/${model.id}`
		);
	}
}
